import React, { useContext } from "react";
import Row from "@amzn/meridian/row";
import FPHView from "../FPH/FPHView";
import ComplianceView from "../complaince/complianceView";
import { getRefreshInterval } from "../overview/utils/utils";
import { RouteContext } from "../outboundAmzl/context/RouteContextProvider";
import { OutboundFilterContext } from "../outboundAmzl/context/OutboundFilterContext";
import { getRouteByStatusCount } from "../outboundAmzl/util/Util";
import MetricView from "../outboundAmzl/MetricView";

const OutboundOverviewView = () => {
  const { viewModel } = useContext(RouteContext);
  const { viewModelF } = useContext(OutboundFilterContext);
  let routeList = viewModel.routeList;

  const filterCluster = (route) => {
    if (viewModelF.cluster.length === 0) {
      return true;
    }
    let result = false;
    viewModelF.cluster.forEach((cluster) => {
      if (route.routeCode.includes(cluster)) {
        result = true;
      }
    });
    return result;
  };
  const filterType = (route) => {
    if (viewModelF.driverType.length === 0) {
      return true;
    }
    let result = false;
    viewModelF.driverType.forEach((driverType) => {
      if (route.routeType.includes(driverType)) {
        result = true;
      }
    });
    return result;
  };
  const filterDeparture = (route) => {
    if (viewModelF.departure.length === 0) {
      return true;
    }
    let result = false;
    viewModelF.departure.forEach((departure) => {
      if (route.routeSLA.includes(departure)) {
        result = true;
      }
    });
    return result;
  };

  routeList = routeList
    .filter((route) => filterCluster(route))
    .filter((route) => filterType(route))
    .filter((route) => filterDeparture(route));

  return (
    <div>
      <Row widths={["grid-3", "grid-3", "grid-3"]} spacingInset="large">
        <FPHView
          fph={{ processName: "pick", refreshRate: getRefreshInterval() }}
        />
        <FPHView
          fph={{ processName: "sort", refreshRate: getRefreshInterval() }}
        />
        <FPHView
          fph={{ processName: "stage", refreshRate: getRefreshInterval() }}
        />
      </Row>
      <Row widths={["grid-3"]} spacingInset="none large">
        <ComplianceView
          compliance={{
            processName: "scanCompliance",
            refreshRate: getRefreshInterval(),
          }}
        />
      </Row>
      <Row
        widths={["grid-3", "grid-3", "grid-3", "grid-3"]}
        spacingInset="large"
      >
        <MetricView
          data={{
            title: "outboundAZML.totalRoutes",
            message: "Total Routes",
            value: routeList.length,
          }}
        />
        <MetricView
          data={{
            title: "outboundAZML.pendingPick",
            message: "Pending Pick",
            value: getRouteByStatusCount("Picked", routeList),
          }}
        />
        <MetricView
          data={{
            title: "outboundAZML.pendingStage",
            message: "Pending Stage",
            value: getRouteByStatusCount("Staged", routeList),
          }}
        />
        <MetricView
          data={{
            title: "outboundAMZL.pendingDepart",
            message: "Pending Depart",
            value: getRouteByStatusCount("Pending Departed", routeList),
          }}
        />
      </Row>
      <Row widths={["grid-3"]} spacingInset="none large">
        <MetricView
          data={{
            title: "outboundAMZL.departedRoutes",
            message: "Departed Routes",
            value: getRouteByStatusCount("Departed", routeList),
          }}
        />
        <MetricView
          data={{
            title: "outboundAMZL.sidelinedRoutes",
            message: "Sidelined Routes",
            value: getRouteByStatusCount("Sidelined", routeList),
          }}
        />
      </Row>
    </div>
  );
};

export default OutboundOverviewView;



// WEBPACK FOOTER //
// ./src/components/outboundOverview/OutboundOverviewView.js